<template>
  <ClientOnly>
    <Teleport to=".backdrop-target">
      <div v-if="showModal">
        <LazyLanguageSwitchDialog @close="close" />
      </div>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
const i18n = useI18n()
const { isLocaleRedirectModalOpen, setLocaleRedirectModal } = useUiState()
const selected_locale = useCookie('selected_locale')
const { userCountryShopAvailable } = useCountryRedirect({
  options: { immediate: false },
})

onMounted(async () => {
  setLocaleRedirectModal(
    userCountryShopAvailable.value &&
      (selected_locale.value === undefined ||
        (typeof selected_locale.value === 'string' &&
          selected_locale.value !== i18n.locale.value)),
  )
})

const close = () => {
  setLocaleRedirectModal(false)
}

const showModal = computed(() => isLocaleRedirectModalOpen.value)
</script>
